const DIARIZATION_LABEL_PATTERN = /^\d*[A-Z]{1,2}$/;

export const formatSpeakerLabel = (speaker: string): string =>
  speaker.length === 1 || DIARIZATION_LABEL_PATTERN.test(speaker) ? `Speaker ${speaker}` : speaker;
